import AppleTouchIcon76 from '../../../images/favicons/apple-touch-icon-76.png';
import AppleTouchIcon120 from '../../../images/favicons/apple-touch-icon-120.png';
import AppleTouchIcon152 from '../../../images/favicons/apple-touch-icon-152.png';
import AppleTouchIcon180 from '../../../images/favicons/apple-touch-icon-180.png';
import AppleTouchIcon192 from '../../../images/favicons/apple-touch-icon-192.png';
import AppleTouchIcon512 from '../../../images/favicons/apple-touch-icon-512.png';
import Favicon16 from '../../../images/favicons/favicon-16.png';
import Favicon24 from '../../../images/favicons/favicon-24.png';
import Favicon32 from '../../../images/favicons/favicon-32.png';
import Favicon64 from '../../../images/favicons/favicon-64.png';
import { FaviconSource } from './types';

const FAVICON_SOURCES = [
    { size: 16, url: Favicon16 },
    { size: 24, url: Favicon24 },
    { size: 32, url: Favicon32 },
    { size: 64, url: Favicon64 },
];

const APPLE_TOUCH_ICON_SOURCES = [
    { size: 76, url: AppleTouchIcon76 },
    { size: 120, url: AppleTouchIcon120 },
    { size: 152, url: AppleTouchIcon152 },
    { size: 180, url: AppleTouchIcon180 },
    { size: 192, url: AppleTouchIcon192 },
    { size: 512, url: AppleTouchIcon512 },
];

export const ICON_SOURCES: FaviconSource[] = [
    ...FAVICON_SOURCES.map((source) => ({ ...source, rel: 'icon' })),
    ...APPLE_TOUCH_ICON_SOURCES.map((source) => ({ ...source, rel: 'apple-touch-icon' })),
];
